import script from "./ChristmasQuizCompleteCorrectPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChristmasQuizCompleteCorrectPage.vue?vue&type=script&setup=true&lang=ts"

import "./ChristmasQuizCompleteCorrectPage.vue?vue&type=style&index=0&id=6fd336e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd336e5"]])

export default __exports__